import axios from "axios";
import firebase from "../../../../firebaseConfig";

export const APIURL = process.env.REACT_APP_API_ENDPOINT;
export const LOGIN_URL = "api/auth/login";
export const REGISTER_URL = "api/auth/register";
export const REQUEST_PASSWORD_URL = "api/auth/forgot-password";

export const ME_URL = "api/me";
export var userIDToken="";

export function login(email, password) {
  return firebase.auth().signInWithEmailAndPassword(email, password)
    .then(() => 
        {
         return firebase.auth().currentUser.getIdToken().then((idToken) => { 
          userIDToken  = idToken;
  				// return  {status:200,success:true,data:{accessToken:idToken}}			  
  				return  {status:200,success:true,accessToken:idToken}			  
		})
  })
  .catch(function(error) {
		return  {status:200,success:false,error:error}
	});
}

export function generateOTP(user) {	
	return axios.post(APIURL+"/user/otp",{user});
}

export function verifyOTP(user,otp) {	
	return axios.post(APIURL+"/user/verify_otp",{user,otp});
}

export function register(email, fullname, username, password) {
  return axios.post(REGISTER_URL, { email, fullname, username, password });
}

export function requestPassword(email) {
  return axios.post(REQUEST_PASSWORD_URL, { email });
}

export function getUserByToken() {
  // Authorization head should be fulfilled in interceptor.
  
  return {
    id: 2,
    username: "user",
    password: "demo",
    email: "user@demo.com",
    accessToken: "access-token-6829bba69dd3421d8762-991e9e806dbf",
    refreshToken: "access-token-f8e4c61a318e4d618b6c199ef96b9e55",
    roles: [2], // Manager
    fullname: "Megan",
    occupation: "Deputy Head of Keenthemes in New York office",
    companyName: "Keenthemes",
    phone: "456669067891",
    address: {
      addressLine: "3487  Ingram Road",
      city: "Greensboro",
      state: "North Carolina",
      postCode: "27409"
    },
    socialNetworks: {
      linkedIn: "https://linkedin.com/user",
      facebook: "https://facebook.com/user",
      twitter: "https://twitter.com/user",
      instagram: "https://instagram.com/user"
    }
  };
}
